import { createAction } from 'redux-actions';

export const setAudiosPageNum = createAction('LIBRARY/SET_AUDIO_LIST_PAG_NUM', value => value);
